export enum HelpTopic {
  FormatOriginal = 'format-original',
  FormatSquare = 'format-square',
  FormatPortrait = 'format-portrait',
  FormatLandscape = 'format-landscape',
  FormatStory = 'format-story',
  FilmFormats = 'film-formats',
  FramePlacement = 'frame-placement',
  SplitReassembly = 'split-reassembly',
}

interface HelpContent {
  title: string
  lines: readonly string[]
}

export const HELP_CONTENT = {
  [HelpTopic.FormatOriginal]: {
    title: 'Original',
    lines: [
      'Keep the source shape and pixels.',
      'Use it beyond the Instagram feed.',
      'Instagram crops feed shapes outside 4:5 to 1.91:1.',
    ],
  },
  [HelpTopic.FormatSquare]: {
    title: 'Square',
    lines: [
      'Recommended: 1080 × 1080.',
      'Great for products and symmetrical photos.',
      'The profile grid hides the outer sides.',
    ],
  },
  [HelpTopic.FormatPortrait]: {
    title: 'Portrait',
    lines: [
      'Recommended: 1080 × 1350.',
      'Best default for people and vertical photos.',
      'The profile grid hides thin side strips.',
    ],
  },
  [HelpTopic.FormatLandscape]: {
    title: 'Landscape',
    lines: [
      'Recommended: 1080 × 566.',
      'Best for panoramas and wide scenes.',
      'The profile grid shows only the center.',
    ],
  },
  [HelpTopic.FormatStory]: {
    title: 'Story',
    lines: [
      'Recommended: 1080 × 1920.',
      'For full-screen Stories and Reel covers.',
      'Keep faces and text outside the shaded bands.',
    ],
  },
  [HelpTopic.FilmFormats]: {
    title: 'Real film sizes',
    lines: [
      'Each paper and photo window uses its real millimetre proportions.',
      'Classic, Go, and Mini create different bottom borders.',
    ],
  },
  [HelpTopic.FramePlacement]: {
    title: 'Photo placement',
    lines: [
      'Fill covers the full film window.',
      'Float keeps the whole photo smaller inside it.',
    ],
  },
  [HelpTopic.SplitReassembly]: {
    title: 'Grid upload order',
    lines: [
      'Exported files are numbered in upload order.',
      'Instagram shows the newest profile post first.',
    ],
  },
} as const satisfies Readonly<Record<HelpTopic, HelpContent>>

export function validateHelpContent(): void {
  const topics = Object.values(HelpTopic)
  if (Object.keys(HELP_CONTENT).length !== topics.length) throw new Error('Help content configuration is incomplete')
  for (const topic of topics) {
    const content = HELP_CONTENT[topic]
    if (!content.title.trim()) throw new Error(`Help topic "${topic}" requires a title`)
    if (content.lines.length > 3 || content.lines.some((line) => !line.trim())) {
      throw new Error(`Help topic "${topic}" requires one to three non-empty lines`)
    }
  }
}
